import axios from "axios";
import React, { useEffect, useState } from "react";
import axiosInstance from "../../../../axios";
import { Loading } from "../../../Other/Loading";
const { REACT_APP_LOGIN_API_BASEURL } = process.env;

const Forms = ({ setModal, title, role, editData }) => {
  let introArr = [];
  if (Array.isArray(editData.introduction)) {
    introArr = editData.introduction;
  } else if (typeof editData.introduction === "string") {
    try {
      const parsed = JSON.parse(editData.introduction);
      if (Array.isArray(parsed)) {
        introArr = parsed;
      }
    } catch (e) {
      introArr = [];
    }
  }
  const list = introArr;
  //"list", list);
  const [introduction, setIntroduction] = useState(introArr);

  const [formvalue, setformvalue] = useState({
    firstName: editData.firstName ? editData.firstName : "",
    lastName: editData.lastName ? editData.lastName : "",
    userName: editData.userName ? editData.userName : "",
    email: editData.email ? editData.email : "",
    phoneNumber: editData.phoneNumber ? editData.phoneNumber : "",
    password: editData.password ? editData.password : "",
    state: editData.state ? editData.state : "",
    countryCode: (editData.userCountryCode || editData.countryCode) ? editData.userCountryCode || editData.countryCode  : "",
    // countryCode: editData.countryCode ? editData.countryCode : "",
    bio: "default_bio",
    role: role,
    introduction: introArr,
    // salary: editData?.salary ? editData?.salary : ""
  });
  const [success, setSuccess] = useState(false);
  const [showpassword, setShowpassword] = useState(false);
  const [error, setError] = useState();
  const [errorMsg, setErrorMsg] = useState("");
  const [load, setLoad] = useState(false);
  const [courses, setCourses] = useState([]);
  //console.log("courses", courses);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const res = await axiosInstance.get(`${REACT_APP_LOGIN_API_BASEURL}/course`);
        setCourses(res?.data?.data?.data || []);
        //console.log("courses", res);
      } catch (error) {
        console.error("Error fetching courses:", error.message);
      }
    };
    fetchCourses();
  }, []);


  const handleCourseCheckbox = (CourseName) => {
    setIntroduction((prev) => {
      if (prev.includes(CourseName)) {
        // Remove if already selected
        return prev.filter((item) => item !== CourseName);
      } else {
        // Add if not selected
        return [...prev, CourseName];
      }
    });
  };
  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setformvalue((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  useEffect(() => {
    setformvalue((prev) => ({
      ...prev,
      introduction: introduction,
    }));
  }, [introduction]);

  const handleIntroductionChange = (e) => {
    const value = e.target.value;
    setIntroduction(
      value
        .split(",")
        .map((item) => item.trim())
        .filter((item) => item)
    );
  };

  useEffect(() => {
    const submitUserData = async () => {
      if (error?.success === true) {
        setLoad(true);

        const editedData = {
          userId: editData.userIds || editData.id,
          firstName: formvalue.firstName,
          lastName: formvalue.lastName,
          userName: formvalue.userName,
          email: formvalue.email,
          phoneNumber: formvalue.phoneNumber,
          countryCode: formvalue.countryCode,
          introduction: formvalue.introduction,
          state: formvalue.state,
          // salary: formvalue.salary,
        };

        const url = (editData.userIds || editData.id)
          ? formvalue.role === "Instructor"
            ? "/admin/edit/instructor"
            : "/admin/edit/student"
          : "/sign-up";

        const data = (editData.userIds || editData.id) ? editedData : formvalue;

        try {
          const res = await axiosInstance.post(`${url}`, data);
          setLoad(false);
          //console.log("res", res.data);

          if (res?.data?.error === false) {
            setSuccess(true);
          } else if (res?.data?.error === true) {
            setErrorMsg(res?.data?.message);
          }
        } catch (err) {
          console.error("Error submitting user data:", err.message);
          setLoad(false);
        }
      }
    };

    submitUserData();
  }, [error]);


  const validate = () => {
    const email = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    const password =
      /^.*(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$-%^&+=\-])([\w.\-]).*$/;

    const userName = /^(?=.*?[a-z]).{5,}$/
    let error = {};

    if (!formvalue.firstName) {
      error.firstName = "Please enter First name";
    } else if (!formvalue.lastName) {
      error.lastName = "Please enter last name";
    } else if (!formvalue.email) {
      error.email = "Please enter Email-id";
    } else if (!email.test(formvalue.email)) {
      error.email = "Invalid Email-ID";
    } else if (!formvalue.userName) {
      error.userName = "Please Enter username";
    } else if (!userName.test(formvalue.userName)) {
      error.userName =
        "The Username you entered is invalid. username must be at least 8 characters long, contain at least one number (0-9) and have at least one upper case letter (A-Z)";
    } else if (!(editData?.userIds || editData?.id) && !password.test(formvalue.password || editData?.password)) {
      error.password =
        "The password you entered is invalid. password must be at least 8 characters long, contain at least one number (0-1) and have at least one upper case letter (A-Z) and one special character (@#$-%^&+=-)";
    } else if (!formvalue.phoneNumber) {
      error.phoneNumber = "Please enter contact number";
    } else if (!formvalue.countryCode) {
      error.countryCode = "Please enter country name";
    } else if (formvalue) {
      //console.log("formvalue", formvalue);
      error.success = true;
    }
    setError(error);
  };

  return (
    <div className="forms-width-55 add-instructor">
      <div className="dashboard-container-new padding-custom-dashboard-0">
        <p>{(editData?.userIds || editData.id) ? `Edit ${title}` : `Add New ${title}`}</p>
      </div>

      <div className="">
        <div className="">
          <div className="margin-top-new-01 margin-r-n">
            <div className="box-shadow-new-01">
              {!success && (
                <div className="form-content">
                  <div className="border-bottom-new-0">
                    <p className="basic-form-01">Personal Information</p>
                  </div>
                  <div className="dashboard-main">
                    <div className="flex-display-50">
                      <div className="margin-top-new-01-0 margin-r-n">
                        <label className="labels-form">First name*</label>
                        <input
                          className="inputs-form"
                          name="firstName"
                          value={formvalue.firstName}
                          onChange={handleChange}
                        />
                        {error?.firstName && (
                          <span className="error-text-new">
                            {error?.firstName}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="flex-display-50">
                      <div className="margin-top-new-01-0 margin-l-n">
                        <label className="labels-form">Last name*</label>
                        <input
                          className="inputs-form"
                          name="lastName"
                          value={formvalue.lastName}
                          onChange={handleChange}
                        />
                        {error?.lastName && (
                          <span className="error-text-new">
                            {error?.lastName}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="dashboard-main">
                    <div className="flex-display-50">
                      <div className="margin-top-new-01-0 margin-r-n">
                        <label className="labels-form">Username*</label>
                        <input
                          className="inputs-form"
                          name="userName"
                          value={formvalue.userName}
                          onChange={handleChange}
                        />
                        {error?.userName && (
                          <span className="error-text-new">
                            {error?.userName}
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="flex-display-50">
                      <div className="margin-top-new-01-0 margin-l-n">
                        <label className="labels-form">Email ID*</label>
                        <input
                          className="inputs-form"
                          name="email"
                          value={formvalue.email}
                          onChange={handleChange}
                          autoComplete="off"
                        />
                        {error?.email && (
                          <span className="error-text-new">{error?.email}</span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="dashboard-main">
                    <div className="flex-display-50">
                      <div className="margin-top-new-01-0 margin-r-n position-relative-password">
                        <label className="labels-form">Password*</label>
                        <input
                          className="inputs-form"
                          name="password"
                          value={formvalue.password}
                          autoComplete="off"
                          onChange={handleChange}
                          type={`${showpassword ? "text" : "password"}`}
                          disabled={(editData?.userIds || editData.id) ? true : false}
                        />
                        <i
                          className={`${showpassword
                            ? "icon-view-password-active"
                            : "icon-view-password"
                            } position-relative-password-icon`}
                          onClick={() => setShowpassword(!showpassword)}
                        ></i>

                        {error?.password && (
                          <span className="error-text-new">
                            {error?.password}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="flex-display-50">
                      <div className="margin-top-new-01-0 margin-l-n">
                        <label className="labels-form">Contact Number</label>
                        <input
                          className="inputs-form"
                          name="phoneNumber"
                          value={formvalue.phoneNumber}
                          onChange={handleChange}
                        />
                        {error?.phoneNumber && (
                          <span className="error-text-new">
                            {error?.phoneNumber}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="dashboard-main">
                    <div className="flex-display-50">
                      <div className="margin-top-new-01-0 margin-r-n">
                        <label className="labels-form">Country</label>
                        <input
                          className="inputs-form"
                          name="countryCode"
                          value={formvalue.countryCode}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="flex-display-50">
                      <div className="margin-top-new-01-0 margin-l-n">
                        <label className="labels-form">State</label>
                        <input
                          className="inputs-form"
                          name="state"
                          value={formvalue.state}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                  {/* <div className="dashboard-main">
                    <div className="flex-display-50">
                      <div className="margin-top-new-01-0 margin-l-n">
                        <label className="labels-form">Salary</label>
                        <input
                          className="inputs-form"
                          type="number"
                          name="salary"
                          value={formvalue.salary}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                  {/* {editData.role === 4 && (
                    <> */}
                  {title === "Instructor" ? (
                    <>
                      <div className="dashboard-main">
                        <div className="margin-top-new-01-0">
                          <label className="labels-form">Select Courses</label>
                          <div className="courses-select-container">
                            {courses.map((course, idx) => (
                              <label key={idx} className="course-checkbox-label">
                                <input
                                  type="checkbox"
                                  checked={introduction.includes(course.CourseName)}
                                  onChange={() => handleCourseCheckbox(course.CourseName)}
                                  className="course-checkbox"
                                />
                                <span>{course.CourseName}</span>
                              </label>
                            ))}
                          </div>
                          <div className="selected-courses-tags">
                            {introduction.map((item, idx) => (
                              <span key={idx} className="course-tag">
                                {item}
                              </span>
                            ))}
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (<></>)}
                  {/* </>
                  )} */}
                  <div className="margin-top-new-01-0 ">
                    <div className="dashboard-main">
                      <div className="radio ">
                        <input type="checkbox" className="cb" id="check1" />
                        <label htmlFor="check1" className="label-data">
                          In Organization
                        </label>
                      </div>
                    </div>
                    {errorMsg ? (
                      <p className="error-text-new">*{errorMsg}</p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="dashboard-main justify-flex-new">
                    <div className="margin-top-new-01-0">
                      {load ? (
                        <Loading />
                      ) : (
                        <button className="export-btn" onClick={validate}>
                          {(editData?.userIds || editData.id) ? "Update" : "Submit"}
                        </button>
                      )}
                    </div>
                    <div className="margin-top-new-01-0">
                      <button
                        className="lastmonth-btn-0"
                        onClick={() => setModal(false)}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>

                </div>
              )}
              {success && (
                <div className="alert-title">
                  <div className="icon-wrapper">
                    <img
                      src={`${process.env.REACT_APP_SMIK_API_BASEURL}/icons/icon-complete-check.svg`}
                      alt="check-complete"
                    />
                  </div>
                  <div className="status-message">
                    <div className="status-title">
                      <p>
                        {(editData.userIds || editData.id)
                          ? ` ${title} has been successfully updated`
                          : ` ${title} has been successfully added`}
                      </p>
                    </div>
                  </div>
                  <div className="margin-top-new-01-0">
                    <button
                      className="lastmonth-btn-0"
                      onClick={() => setModal(false)}
                    >
                      Close
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Forms;
